
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetohyderabadinnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Innova Crysta Taxi Fare',
        heading: 'Meghana Cab : Pune to Hyderabad Innova Crysta Taxi Fare',
        headingDescription: 'Meghana Cab offers transparent Pune to Hyderabad Innova Crysta Taxi Fare, ensuring premium comfort and complete cost clarity on your long-distance journey. Covering approximately 560–562 km over a 10–11 hour drive, our Innova Crysta provides spacious leather interiors, ample luggage space, and a smooth ride—ideal for families, groups, and corporate travelers.',


        top: 'Top Places to Visit in Hyderabad with Meghana Cab',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "A defining symbol of Hyderabad, the Charminar is a 16th-century monument built by Muhammad Quli Qutb Shah to commemorate the end of a plague. This Indo-Islamic marvel features four grand arches and towering minarets, each 56 meters high, providing panoramic views of the bustling Old City. Surrounded by vibrant markets like Laad Bazaar, Charminar is both a historical icon and a cultural hub teeming with street food, pearl shops, and traditional Hyderabadi jewelry."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic 13th-century citadel renowned for its acoustic architecture, massive gates, and panoramic views of Hyderabad city. Once the capital of the Qutb Shahi dynasty, the fort includes royal apartments, mosques, and an ingenious water system. Don’t miss the evening light-and-sound show that recounts the fort’s glorious history with dramatic flair. The fort is also linked with the famous Koh-i-Noor diamond, which was reportedly mined here."
  },
  {
    "title": "Ramoji Film City",
    "description": "Spread over 2,000 acres, Ramoji Film City is the world’s largest integrated film studio complex and a popular family attraction. It features movie sets, theme parks, gardens, live shows, and adventure zones. Visitors can explore replicas of airport terminals, railway stations, royal palaces, and global landmarks. A guided tour offers a behind-the-scenes glimpse into filmmaking, making it a unique mix of entertainment, technology, and creativity."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Constructed in 1562, Hussain Sagar is a large heart-shaped artificial lake that separates Hyderabad from Secunderabad. At its center stands a towering 18-meter monolithic Buddha statue on Gibraltar Rock Island. Visitors enjoy boat rides, evening cruises, and the view of the illuminated statue. The lake is bordered by Lumbini Park, Necklace Road, and Tank Bund, making it a favored spot for evening strolls and romantic outings."
  },
  {
    "title": "Birla Mandir",
    "description": "Situated atop a 280-foot high hillock called Naubath Pahad, Birla Mandir is a serene white marble temple dedicated to Lord Venkateshwara (Balaji). Built without using steel, the temple’s intricate carvings, blend of Rajasthani, Utkala, and Dravidian architecture, and panoramic views of the city and Hussain Sagar Lake make it a spiritual and visual delight. It’s especially beautiful during sunset hours."
  },
  {
    "title": "Salar Jung Museum",
    "description": "This world-renowned museum houses one of the largest one-man collections of art, artifacts, and antiques in the world, curated by Nawab Mir Yousuf Ali Khan, Salar Jung III. The museum’s galleries showcase everything from Persian carpets and Mughal miniatures to European sculptures and Japanese samurai armor. The Veiled Rebecca statue and the double-faced clock are standout attractions. With over 40,000 exhibits, it's a treasure trove for art lovers and historians."
  },
  {
    "title": "Mecca Masjid",
    "description": "One of India’s largest and oldest mosques, Mecca Masjid was commissioned by Muhammad Quli Qutb Shah and completed by Mughal emperor Aurangzeb in 1694. Built with bricks brought from Mecca, the mosque can accommodate over 10,000 worshippers. Its vast courtyard, granite arches, and carved interiors exemplify Islamic architecture. Located near Charminar, it's a must-visit for spiritual travelers and history buffs."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "The former seat of the Asaf Jahi dynasty, Chowmahalla Palace reflects the opulence of the Nizams of Hyderabad. Spread over 12 acres, the palace complex includes the grand Khilwat Mubarak, Council Hall, and an exquisite clock tower. Visitors can admire Belgian chandeliers, vintage cars, royal costumes, and ornate furniture. It's a beautiful blend of Persian, Indo-Saracenic, and European architectural styles."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Established in 1959, Nehru Zoological Park spans over 380 acres and is home to more than 1,500 species of animals, birds, and reptiles. It features safari rides, a toy train, nocturnal houses, and a butterfly park. Popular among families and school tours, the zoo also conducts educational programs and wildlife awareness activities, offering both fun and learning."
  },
  {
    "title": "Shilparamam",
    "description": "Located in Hitech City, Shilparamam is an arts and crafts village that showcases India’s traditional handicrafts, tribal art, and cultural performances. Visitors can shop for handmade goods, watch live folk dances, or explore the sculpture park and rural museum. It's a tranquil escape from the tech-driven buzz of Cyberabad and a great place to explore Indian heritage under one roof."
  }
],

  "services": [
    {
      "name": "Pune to Hyderabad Innova Crysta Taxi Fare",
      "description": "Get transparent and competitive taxi fare for your Pune to Hyderabad journey in an Innova Crysta. Our pricing includes fuel, tolls, and driver allowance—ensuring no hidden charges and a smooth, comfortable ride for families, corporates, or long-distance travelers."
    },
    {
      "name": "Affordable Innova Crysta Pune Hyderabad",
      "description": "Travel affordably from Pune to Hyderabad with our well-maintained Innova Crysta cabs. Offering the perfect mix of comfort, space, and cost-efficiency, our fares are designed for both one-way and round trips with complete fare breakdown available upfront."
    },
    {
      "name": "Pune Hyderabad Innova Crysta Cab Cost",
      "description": "Check our all-inclusive cab cost for the Pune to Hyderabad route. With no surprises in billing, our rates cover everything from AC usage to distance-based charges—making your booking reliable and budget-friendly."
    },
    {
      "name": "Budget Innova Crysta Taxi Fare Pune to Hyderabad",
      "description": "Looking for a budget-friendly ride to Hyderabad from Pune? Book an Innova Crysta at an economical fare without compromising on luxury. Ideal for groups or family travel, our packages include daily rental + km fare slabs."
    },
    {
      "name": "Online Fare Estimate Innova Crysta Pune Hyderabad",
      "description": "Use our online fare calculator to get an instant estimate for your Pune to Hyderabad trip in an Innova Crysta. Just enter your travel date, trip type (one way/round trip), and get accurate pricing within seconds."
    },
    {
      "name": "Best Innova Crysta Fare Pune to Hyderabad",
      "description": "Compare and book the best-priced Innova Crysta fares for the Pune to Hyderabad route. We match comfort with competitive pricing and offer deals for advance bookings or corporate travel requirements."
    },
    {
      "name": "Hyderabad Trip Innova Crysta Pune",
      "description": "Planning a trip to Hyderabad from Pune? Our Innova Crysta service comes with fixed fare options, experienced chauffeurs, and all-India permit—ideal for stress-free intercity travel, sightseeing, or corporate visits."
    },
    {
      "name": "Cheap Innova Crysta Taxi Pune Hyderabad",
      "description": "Get the lowest possible taxi rates for Pune to Hyderabad Innova Crysta bookings without sacrificing quality. Book early or choose weekday travel to avail additional discounts and exclusive offers."
    },
    {
      "name": "Fixed Fare Innova Crysta Pune Hyderabad",
      "description": "Enjoy peace of mind with our fixed fare packages for Pune to Hyderabad in an Innova Crysta. No per-kilometer confusion—just one clear rate covering your complete journey."
    },
    {
      "name": "Pune Hyderabad Innova Crysta Rental Price",
      "description": "Our Innova Crysta rental prices for Pune to Hyderabad are designed for flexibility. Whether it’s one-way, round-trip, or multi-day stay, we offer options suited to your budget and schedule."
    },
    {
      "name": "Hyderabad Innova Crysta Taxi Charges",
      "description": "Know exactly what you’re paying for with our transparent taxi charges for the Pune–Hyderabad route in Innova Crysta. Charges include base fare, additional km rate, driver night allowance (if applicable), and return cost (for one-way)."
    },
    {
      "name": "Innova Crysta Fare Comparison Pune Hyderabad",
      "description": "Compare Pune to Hyderabad Innova Crysta fares from multiple providers on one platform. We help you find the best balance of cost, comfort, and service quality for your intercity travel needs."
    },
    {
      "name": "Pune to Hyderabad Cab Rates",
      "description": "Explore up-to-date cab rates for Pune to Hyderabad including per-kilometer pricing, fixed fares, and round-trip offers. Our team ensures you get competitive rates along with premium vehicle quality."
    },
    {
      "name": "Taxi Fare Pune Hyderabad Innova Crysta",
      "description": "Check our detailed taxi fare chart for Innova Crysta travel from Pune to Hyderabad. Perfect for group trips, outstation work travel, or temple visits—our service includes fully sanitized cabs, reliable support, and GPS tracking."
    },
    {
      "name": "Pune Hyderabad Innova Crysta Cost Calculator",
      "description": "Use our smart cost calculator to estimate your Pune–Hyderabad Innova Crysta ride. Input distance, number of days, or special requirements, and get customized fare instantly—ensuring clarity before you book."
    }
  ],
  "tableData": [
    ["Pune to Hyderabad Innova Crysta Taxi Fare", "Affordable Innova Crysta Pune Hyderabad"],
    ["Pune Hyderabad Innova Crysta Cab Cost", "Budget Innova Crysta Taxi Fare Pune to Hyderabad"],
    ["Online Fare Estimate Innova Crysta Pune Hyderabad", "Best Innova Crysta Fare Pune to Hyderabad"],
    ["Hyderabad Trip Innova Crysta Pune", "Cheap Innova Crysta Taxi Pune Hyderabad"],
    ["Fixed Fare Innova Crysta Pune Hyderabad", "Pune Hyderabad Innova Crysta Rental Price"],
    ["Hyderabad Innova Crysta Taxi Charges", "Innova Crysta Fare Comparison Pune Hyderabad"],
    ["Pune to Hyderabad Cab Rates", "Taxi Fare Pune Hyderabad Innova Crysta"],
    ["Pune Hyderabad Innova Crysta Cost Calculator", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Innova Crysta Taxi from Pune to Hyderabad",
    "WhyChoosedescription": "Enjoy a smooth, spacious, and premium ride from Pune to Hyderabad with our Innova Crysta taxi service. Ideal for business travelers, families, and small groups, we ensure a hassle-free travel experience over the 560+ km interstate route."
  },
  {
    "WhyChooseheading": "Spacious and Feature-Rich Travel for Long Journeys",
    "WhyChoosedescription": "The Innova Crysta is designed for long-distance comfort with plush seats, powerful AC, ample luggage room, and seating for up to 6–7 passengers. The smooth suspension and quiet cabin ensure a relaxed ride across state borders."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Interstate Travel",
    "WhyChoosedescription": "Our professional chauffeurs are experienced in long-distance driving and well-acquainted with Pune–Hyderabad highway routes. They ensure a safe, timely, and comfortable ride, with optional rest stops along the way."
  },
  {
    "WhyChooseheading": "Well-Maintained, Sanitized Vehicles",
    "WhyChoosedescription": "All Innova Crysta cabs are regularly serviced and sanitized before every trip. We uphold the highest standards in vehicle cleanliness and safety, especially for interstate journeys that demand comfort and reliability."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Taxi Fare",
    "WhyChoosedescription": "Our Pune to Hyderabad Innova Crysta taxi fare includes driver allowance, fuel, tolls, and interstate taxes. We provide upfront pricing with no hidden costs—offering premium service with total transparency."
  },
  {
    "WhyChooseheading": "Flexible Booking Options – One-Way or Round Trip",
    "WhyChoosedescription": "Whether you're planning a one-way drop or a round trip with return in a few days, we offer customized fare packages to suit your itinerary. Book in advance or on short notice—we’re flexible to your travel plans."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, or Group Travel",
    "WhyChoosedescription": "Our Innova Crysta taxis are ideal for long business trips, family visits, student relocation, or group tours. Everyone onboard gets ample space, comfort, and a peaceful journey to Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and On-Road Assistance",
    "WhyChoosedescription": "Our customer support is available round the clock to help with bookings, updates, or roadside assistance. Travel worry-free with full service support from departure to destination."
  }
]




























    }

const faqData = [
    {
        question: "What is the approximate taxi fare for Innova Crysta from Pune to Hyderabad?",
        answer: "The fare varies based on distance, route, and additional charges but typically ranges between ₹8,000 to ₹12,000."
    },
    {
        question: "How is the Pune to Hyderabad Innova Crysta taxi fare calculated?",
        answer: "Fare includes base distance charges, fuel, tolls, driver fees, and applicable taxes."
    },
    {
        question: "Are there any extra charges apart from the basic fare?",
        answer: "Additional charges may apply for waiting time, extra stops, night travel, or parking fees."
    },
    {
        question: "Can I get a fixed fare quote before booking?",
        answer: "Yes, you can contact Meghana Cab at +91 9075462128 for a precise fare estimate."
    },
    {
        question: "Is the fare negotiable for long-distance trips?",
        answer: "We offer competitive pricing and discounts for long-distance and round trips."
    },
    {
        question: "What payment methods are accepted for the taxi fare?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Does the fare include toll and parking charges?",
        answer: "Yes, toll charges are included; parking fees may be extra depending on the stops."
    },
    {
        question: "Are taxes included in the quoted fare?",
        answer: "Yes, all applicable taxes are included in the fare."
    },
    {
        question: "Can I pay online or after the trip?",
        answer: "Both online and cash payments are accepted as per your convenience."
    },
    {
        question: "How do I confirm the taxi fare before booking?",
        answer: "Call us at +91 9075462128 or visit our website to get a confirmed fare quotation."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Mehta',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The fare for Pune to Hyderabad Innova Crysta was reasonable and transparent. Great service overall.”',
    },
    {
        name: 'Ms. Neha Reddy',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent value for money on our Pune to Hyderabad trip. The driver was punctual and the ride comfortable.”',
    },
];


























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneToHyderabadFareSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Hyderabad Innova Crysta Taxi Fare",
  "description": "Affordable and budget-friendly Innova Crysta taxi fare from Pune to Hyderabad. Get online fare estimates, fixed pricing, and best taxi rates for your Pune to Hyderabad trip.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Taxi Fare Estimation",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Hyderabad"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-hyderabad-innova-crysta-taxi-fare"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Hyderabad Innova Crysta Taxi Fare | Affordable Cab Rates</title>
  <meta
    name="description"
    content="Check affordable Innova Crysta taxi fares from Pune to Hyderabad. Get budget-friendly prices, fixed fare options, and online fare estimates for your Hyderabad trip."
  />
  <meta
    name="keywords"
    content="Pune to Hyderabad Innova Crysta Taxi Fare, Affordable Innova Crysta Pune Hyderabad, Pune Hyderabad Innova Crysta Cab Cost, Budget Innova Crysta Taxi Fare Pune to Hyderabad, Online Fare Estimate Innova Crysta Pune Hyderabad, Best Innova Crysta Fare Pune to Hyderabad, Hyderabad Trip Innova Crysta Pune, Cheap Innova Crysta Taxi Pune Hyderabad, Fixed Fare Innova Crysta Pune Hyderabad, Pune Hyderabad Innova Crysta Rental Price, Hyderabad Innova Crysta Taxi Charges, Innova Crysta Fare Comparison Pune Hyderabad, Pune to Hyderabad Cab Rates, Taxi Fare Pune Hyderabad Innova Crysta, Pune Hyderabad Innova Crysta Cost Calculator"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToHyderabadFareSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetohyderabadinnovacrysta;